<template>
  <div class="td-box">
    <UpShopBtn
      v-if="getValue.type === 'upShopBtn'"
      :data="getValue"
      @change="onUpShopBtn"
    />
    <Buttons
      v-else-if="getValue.type === 'buttons'"
      :data="getValue"
      @change="onButtons"
    />
    <TimeRange
      v-else-if="getValue.type === 'timeRange'"
      :data="getValue"
    />
    <span
      v-else
      class="word"
    >
      {{getValue.value}}
    </span>
  </div>
</template>

<script>
import UpShopBtn from './components/upShopBtn'
import Buttons from './components/buttons'
import TimeRange from './components/timeRange'
export default {
  name: 'operations',
  components: {
    UpShopBtn,
    Buttons,
    TimeRange
  },
  props: {
    row: [Array, Object],
    item: [Array, Object]
  },
  computed: {
    getValue () {
      const obj = {}
      try {
        obj.type = this.item.filter
        // 过滤条件优先
        if (this.item.filter) {
          // console.log(this.item.filter)

          switch (this.item.filter) {
            // 上架
            case 'upShopBtn':
              obj.name = this.item.filterOptions[this.row[this.item.prop]]
              obj.value = this.row[this.item.prop]
              break
            // 按钮组
            case 'buttons':
              obj.options = this.item.filterOptions
              obj.value = this.row[this.item.prop]
              break
            // 时间段
            case 'timeRange':
              obj.value = this.row[this.item.prop]
              break
            default:
              obj.value = this.item.filterOptions[this.row[this.item.prop]]
          }
          return obj
        }

        obj.value = this.row[this.item.prop]
      } catch (e) {
        console.log('等待获取表格单元值==>')
      }
      return obj
    }
  },
  methods: {
    onUpShopBtn (value) {
      this.$emit('onTdBox', value)
    },
    onButtons (value) {
      this.$emit('onTdBoxClick', value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .td-box{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .btn{
      margin-right: 10px;
      color: #409EFF;
      font-weight: 500;
      cursor: pointer;
      border-bottom: 1px solid rgba(0,0,0,0);

      &:hover {
        border-bottom: 1px solid #409EFF;
      }

      &:last-child{
        margin-right: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IMTable/components/tdBox/index.vue